const getEventKey = (params) => {
  const { page, action, actionType } = params;
  return [page, actionType, action].filter((value) => value !== void 0).join("_");
};

export { getEventKey };
//# sourceMappingURL=getEventKey.mjs.map
